<template>
  <div class="winbidContract">
    <project-table :operateColumns="operateColumns" :extraQuery="extraQuery" :extraSearch="extraSearch" multipleArea>
      <span slot="extraBtn">
        <Button type="primary" style="margin-left: 10px" @click="showReserchForm=true">档案调研申请表</Button>
        <Button type="success" style="margin-left: 10px" @click="reportVisible=true">中标资料一览</Button>
      </span>
    </project-table>
    <!-- 报表 -->
    <Modal v-model="reportVisible" title="投标资料一览" width="88%">
      <iframe :src="reportUrl" style="width:100%;height:500px;border:0"></iframe>
      <div slot="footer"></div>
    </Modal>
    <!-- 档案调阅申请表 -->
    <Modal v-model="showReserchForm" title="档案调阅申请表" width="680">
      <research-form ref="form2" :projectList="projectList" @startFlow="startFlow"></research-form>
      <div slot="footer" style="text-align:center">
        <Button @click="$refs.form2.validFrom()" type="primary">提交</Button>
        <Button @click="showReserchForm=false">取消</Button>
      </div>
    </Modal>
    <!-- 流程人员选择 -->
    <Modal title="流程人员选择" v-model="peopleDialogVisible" width="700px" id="peopleDialog" :mask-closable="false">
			<PeopleSel :child-msg="peopleObj" @toparentevent="(e)=>{chosedPeopleObj=e}"></PeopleSel>
			<div slot="footer" class="dialog-footer">
				<Button v-if="peopleObj.NextActivityName != '结束'" type="primary" @click="handlePeopleClick(1)">下一步</Button>
				<Button v-else type="primary" @click="handlePeopleClick(0)">结 束</Button>
				<Button type="primary" @click="peopleDialogVisible = false">关 闭</Button>
			</div>
			<Spin fix v-if="endflowSpin">正在处理，请稍候..</Spin>
		</Modal>
    <!-- 登记表 -->
    <Modal title="档案管理员登记" v-model="showSheet" id="peopleDialog" width="580">
      <Form ref="form" :model="form" :rules="rules">
        <Row>
          <Col span="12">
            <FormItem label="合同类型:" prop="contactType" required>
              <Select v-model="form.contactType" style="width:160px">
                <Option v-for="type in ['原件','复印件']" :key="type" :value="type">{{type}}</Option>
              </Select>
            </FormItem>
          </Col>
          <Col span="12">
            <FormItem label="签订日期:" prop="contactDate" required>
              <DatePicker type="date" style="width:160px" v-model="form.contactDate"></DatePicker>
            </FormItem>
          </Col>
          <Col span="12">
            <FormItem label="收取方式:" prop="receiveType" required>
              <Select v-model="form.receiveType" style="width:160px" @on-change="form.courierNumber=''">
                <Option v-for="type in ['邮寄快递','现场提交']" :key="type" :value="type">{{type}}</Option>
              </Select>
            </FormItem>
          </Col>
          <Col span="12" v-if="form.receiveType==='邮寄快递'">
            <FormItem label="快递单号:" prop="courierNumber" required>
              <Input v-model="form.courierNumber" placeholder="请输入快递单号" style="width:160px"></Input>
            </FormItem>
          </Col>
          <Col span="12">
            <FormItem label="档案人员:" prop="archivist" required>
              <Input v-model="form.archivist" style="width:160px"></Input>
            </FormItem>
          </Col>
          <Col span="12">
            <FormItem label="存档日期:" prop="contactSaveDate" required>
              <DatePicker type="date" style="width:160px" v-model="form.contactSaveDate"></DatePicker>
            </FormItem>
          </Col>
          <!-- <Col span="12">
            <FormItem label="装箱箱号:">
              <Input v-model="form.packageCount" disabled></Input>
            </FormItem>
          </Col> -->
          <Col span="24" style="margin-left:34px">
            <FormItem label="备注:">
              <Input v-model="form.fileRemark" type="textarea" style="width:440px"></Input>
            </FormItem>
          </Col>
        </Row>
      </Form>
			<div slot="footer" style="text-align:center">
        <Button @click="submit" type="primary">提交</Button>
        <Button @click="showSheet=false">取消</Button>
      </div>
		</Modal>
  </div>
</template>

<script>
import ajax from '@/lib/ajax'
import userAjax from '@/lib/userAjax'
import requestUrls from '@/lib/requestUrls'
import ProjectTable from '@/components/projectTable'
import { getProjectPermission } from "@/lib/projectPermission"
import { formatDate } from '@/lib/tool'
import qs from "qs"
import researchForm from './researchForm'
import PeopleSel from "@/components/workflow/peopleSelect"

export default {
  components: {
    ProjectTable,
    researchForm,
    PeopleSel
  },
  data() {
    const validateDate = (rule, value, callback) => {
      if (value === '') {
        callback(new Error('Please enter your password'));
      } else {
        callback()
      }
    }
    return {
      wfUrl: 'http://qy.chinapsp.cn:45100',
      operateColumns: [
        {
          title: '操作',
          width: 200,
          render: (h, params) => {
            return h('div', [
              h('Button', {
                props: {
                  type: 'primary',
                  size: 'small',
                  disabled: params.row.isFileRegister === '1'
                },
                style: {
                  marginRight: '5px'
                },
                on: {
                  click: () => {
                    this.currentProject = params.row
                    this.showSheet = true
                  }
                }
              }, '档案管理员登记'),
              h('Button', {
                props: {
                  type: 'error',
                  size: 'small',
                  disabled: params.row.isFileRegister !== '1'
                },
                style: {
                  marginRight: '5px'
                },
                on: {
                  click: async () => {
                    this.currentProject = params.row
                    // 获取填写数据记录
                    let rep = await ajax.get(requestUrls.CLBidFile.GetPaged, {
                      params: {
                        filter: `projectId == ${params.row.id}`
                      }
                    })
                    this.form = rep.data.result.items[0]
                    this.showSheet = true
                  }
                }
              }, '修正')
            ])
          }
        }
      ],
      projectList: [],
      permission: {
        type: ' and type=="开评标" and roomId >= "0"',
      },
      extraQuery: {
        status: ' and (projectState.Contains("已开评标完") or projectState.Contains("项目失败") or projectState.Contains("项目结项"))'
      },
      extraSearch: {
        moreSearch: true
      },
      isShow: false,
      currentProject: {},
      reportVisible: false,
      reportUrl: 'http://report.choicelink.cn:8095/WebReport/ReportServer?reportlet=cailian/档案管理/中标合同存档登记表.cpt',
      showReserchForm: false,
      peopleDialogVisible: false,
      peopleObj: {}, //选人子组件通信
      chosedPeopleObj: {}, //选人子组件返回
      endflowSpin: false,
      showSheet: false,
      form: {
        contactType: '',
        contactDate: '',
        receiveType: '',
        courierNumber: '', // 快递单号
        archivist: this.$store.state.session.user.name,
        // packageCount: ''
        fileRemark: '',
        contactSaveDate: ''
      },
      rules: {
        contactType: [
          { required: true, trigger: 'blur', message: '合同类型不能为空' }
        ],
        contactDate: [
          { required: true, trigger: 'blur', message: '签订日期不能为空', type: 'date' }
        ],
        contactSaveDate: [
          { required: true, trigger: 'blur', message: '签订日期不能为空', type: 'date' }
        ],
        receiveType: [
          { required: true, trigger: 'blur', message: '收取方式不能为空' }
        ],
        archivist: [
          { required: true, trigger: 'blur', message: '档案人员不能为空' }
        ],
        courierNumber: [
          { required: true, trigger: 'blur', message: '快递单号不能为空' }
        ]
      }
    }
  },
  computed: {
    userInfo () {
      return this.$store.state.session.user
    }
  },
  watch: {
    showSheet (val) {
      if (!val) this.$refs.form.resetFields()
    }
  },
  methods: {
    startFlow (param, title) {
      // let processVariablesJson = JSON.stringify([{ key: 'status', value: self.$refs[this.refType].xmlObj.category.projectnature }])
      this.formData = param
      this.title = title
      this.$Spin.show()
      ajax({
        method: "post",
        url: this.wfUrl + "/WorkflowBusinessRESTfullApi/GetActivityInfoIUsers",
        data: qs.stringify({
						authorJson: JSON.stringify({
							"loginAccount": this.userInfo.phoneNumber
						}),
						parmJson: JSON.stringify({
							"appId": 'DY',
							"taskId": "",
							"processVariablesJson": ''
						})
					})
      }).then(res => {
        this.$Spin.hide()
        this.peopleObj = res.data[0]
        this.peopleDialogVisible = true
      })
    },
    handlePeopleClick (num) {
      if ((!!this.chosedPeopleObj.userId && num == 1) || num == 0) {
        // 新建发起
        this.$Spin.show()
        ajax({
          method: "post",
          url: this.wfUrl + "/WorkflowBusinessRESTfullApi/StartWorkflow/",
          data: qs.stringify({
            "authorJson": JSON.stringify({
              "loginAccount": this.userInfo.phoneNumber
            }),
            "parmJson": JSON.stringify({
              "appId": 'DY',
              "wiid": this.formData.flowId,
              // "businessKey": this.formData.expectReturnDate, // 记录是否归还
              "businessKey": JSON.stringify({
                isReturn: this.formData.isReturn,
                remark: this.formData.isReturn === '是' ? this.formData.expectReturnDate : this.formData.notReturnReason
              }), // 记录是否归还
              "title": this.title,
              "opinion": "流程发起",
              "toUserNameOrId": "",//用途不明
              "toActivityList": "{'" + this.peopleObj.NextActivityCode + "':'" + this.chosedPeopleObj.userId + "'}",
              "processVariablesJson": ""//用途不明
            }),
          })
        }).then((res) => {
          if (res.status == 200) {
            ajax.post(requestUrls.CLShiftingFile.CreateOrUpdate, {
              clShiftingFile: this.formData
            }).then(res => {
              this.$Spin.hide()
              this.$Message.success('提交成功！')
              this.showReserchForm = false
              this.peopleDialogVisible = false
            })
          }
        })
      } else {
        this.$Message.error("未选择审核人员")
      }
    },
    submit () {
      this.$refs.form.validate(async (valid) => {
        if (valid) {
          // 获取历史填写数据
          let rep = await ajax.get(requestUrls.CLBidFile.GetPaged, {
            params: {
              filter: `projectId == ${this.currentProject.id}`
            }
          })
          let clBidFile
          if (rep.data.result.totalCount) {
            clBidFile = Object.assign(rep.data.result.items[0], this.form)
          } else {
            clBidFile = Object.assign(this.form, {
              projectId: this.currentProject.id,
              projectName: this.currentProject.name,
              projectShort: this.currentProject.projectShort,
              projectFull: this.currentProject.projectFull,
              area: this.currentProject.district,
              openBidDate: this.currentProject.clMeetingRoom.beginTime
            })
          }
          ajax.post(requestUrls.CLBidFile.CreateOrUpdate, {
            clBidFile
          }).then(res =>{
            this.$Message.success('登记成功!')
            this.showSheet = false
            // 更新项目登记状态
            this.currentProject.isFileRegister = '1'
            ajax.post(requestUrls.ClProjectDb.CreateOrUpdate, {
              clProjectDb: this.currentProject
            })
          })
        } else {
          this.$Message.error('Fail!');
        }
      })
    }
  }
}
</script>

<style lang="less">
.winbidContract {
  .modal {
    .ivu-modal {
      top: 20px;
    }
  }
  .eva-modal {
    .ivu-modal {
      top: 0;
      height: 100%;
    }
    .ivu-modal-content {
      height: 100%;
    }
    .ivu-modal-body {
      height: 90%;
    }
  }
  .modal-label {
    font-size: 14px;
    font-weight: 600;
    text-align: right;
    padding-right: 10px;
  }
  .modal-value {
    font-size: 14px;
    margin-bottom: 15px;
  }
}
</style>
